import axios from "axios";

export const baseUrl = "https://api.deets.digital/v1/deets";
export let timoutReq = 10000;

// A request that never got a response — network drop, CORS rejection, or the
// timeout above — carries no `error.response`. Returning that undefined makes
// `er` falsy, and every `if (res.er)` call site then reads the failure as a
// success. Synthesise the same { data: { message } } shape callers already read.
const toErrorResult = (error) => ({
  er: error.response || { data: { message: error.message } },
});

export const axiosCalls = async (path, method, data = null) => {
  const token = localStorage.getItem("token");
  try {
    let res = await axios({
      method,
      url: `${baseUrl}/${path}`,
      data,
      timeout: timoutReq,
      headers: {
        Authorization: `Bearer ${token}`,
        prefer: "params=single-object",
        // "Content-Type": "application/octet-stream",
      },
    });
    if (res) {
      return res;
    }
  } catch (error) {
    return toErrorResult(error);
  }
};

export const axiosCallSignup = async (path, method, data = null) => {
  // const token = localStorage.getItem("token");
  try {
    let res = await axios({
      method,
      url: `${baseUrl}/${path}`,
      data,
      timeout: timoutReq,
      headers: {
        prefer: "params=single-object",
      },
    });
    if (res) {
      return res;
    }
  } catch (error) {
    return toErrorResult(error);
  }
};
